var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_689_2360)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_689_2360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 23.1C5.00001 31.9365 12.1635 39.1 21 39.1H48V3.74443H5.00001V23.1Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.00003 3.74443C5.00003 3.74443 10.9395 11.8855 26.2137 11.8666C41.4879 11.8477 47.5222 3.74443 47.5222 3.74443L5.00003 3.74443Z",
    fill: "url(#paint0_linear_689_2360)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1475 23V16.335H11.8242V19.0449H9.02637V16.335H7.70802V23H9.02637V20.1436H11.8242V23H13.1475ZM15.8818 23V16.335H14.5635V23H15.8818ZM16.8779 21.1055C16.8975 22.0332 17.5274 23.127 19.4609 23.127C21.0674 23.127 22.1025 22.3457 22.1025 21.0371C22.1025 19.8457 21.2969 19.3721 20.3106 19.1572L19.2754 18.918C18.6748 18.7861 18.3623 18.5127 18.3623 18.1123C18.3623 17.5703 18.8164 17.2334 19.5244 17.2334C20.3252 17.2334 20.7207 17.6777 20.7647 18.1758H22.0049C21.9854 16.9795 20.96 16.1982 19.5293 16.1982C18.1572 16.1982 17.044 16.916 17.044 18.2148C17.044 19.333 17.8203 19.8506 18.7334 20.0557L19.7637 20.2949C20.4522 20.4512 20.7891 20.6904 20.7891 21.1592C20.7891 21.7109 20.3447 22.082 19.5342 22.082C18.6602 22.082 18.1963 21.623 18.1524 21.1055H16.8779ZM25.7744 23V17.4385H27.669V16.335H22.5615V17.4385H24.4561V23H25.7744ZM33.7871 20.1191V19.2646C33.7871 17.3799 32.7227 16.208 30.9356 16.208C29.1582 16.208 28.0742 17.3701 28.0742 19.2646V20.1191C28.0742 21.999 29.1436 23.127 30.9258 23.127C32.708 23.127 33.7871 21.999 33.7871 20.1191ZM32.4492 19.2549V20.124C32.4492 21.4082 31.8145 22.0283 30.9307 22.0283C30.0518 22.0283 29.417 21.4082 29.417 20.124V19.2549C29.417 17.9707 30.0518 17.3066 30.9307 17.3066C31.8145 17.3066 32.4492 17.9707 32.4492 19.2549ZM37.5957 16.335H34.9346V23H36.2334V20.5146H37.4199L38.5869 23H40.0615L38.7188 20.3145C39.2266 20.1143 39.9346 19.5381 39.9346 18.4443C39.9346 17.2676 39.1777 16.335 37.5957 16.335ZM36.2334 19.5234V17.3701H37.4053C38.084 17.3701 38.5723 17.7363 38.5723 18.4688C38.5723 19.1572 38.1279 19.5234 37.3857 19.5234H36.2334ZM43.7725 23V20.4414L46.0039 16.335H44.5781L43.1524 19.1621H43.1035L41.6826 16.335H40.2227L42.4541 20.4658V23H43.7725Z",
    fill: "#5D3800"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_689_2360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.2556,
    y: 0.399994,
    width: 2.86667,
    height: 6.68889,
    rx: 1.43333,
    fill: "url(#paint1_linear_689_2360)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_689_2360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.8778,
    y: 0.399994,
    width: 2.86667,
    height: 6.68889,
    rx: 1.43333,
    fill: "url(#paint2_linear_689_2360)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.03318 20.9444C5.03318 20.9444 7.55556 31.7333 19.5 26C13.7667 36.2722 23.1887 39.1 23.1887 39.1L22.1447 39.1465C12.0719 39.5956 3.96344 30.9703 5.03318 20.9444Z",
    fill: "url(#paint3_linear_689_2360)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 31H44",
    stroke: "#5D3800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4428 26.83L44.4714 30.8587L40.4428 34.8873",
    stroke: "#5D3800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_689_2360",
    x: 0.938194,
    y: 0.399994,
    width: 51.0618,
    height: 46.7633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_689_2360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_689_2360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_689_2360",
    x: 1.00001,
    y: 3.74443,
    width: 51,
    height: 43.3556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_689_2360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_689_2360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_689_2360",
    x: 9.25556,
    y: 0.399994,
    width: 4.86667,
    height: 9.68889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_689_2360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_689_2360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_689_2360",
    x: 38.8778,
    y: 0.399994,
    width: 4.86667,
    height: 9.68889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_689_2360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_689_2360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_689_2360",
    x1: 26.2611,
    y1: 3.68081,
    x2: 26.2611,
    y2: 7.75251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1394D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94A42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_689_2360",
    x1: 11.6889,
    y1: 0.399994,
    x2: 11.6889,
    y2: 7.08888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766587,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_689_2360",
    x1: 41.3111,
    y1: 0.399994,
    x2: 41.3111,
    y2: 7.08888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766587,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_689_2360",
    x1: 12.1999,
    y1: 31.4555,
    x2: 9.0943,
    y2: 36.7111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.c5440c34e6da0feef8d0b2723301ef3e.svg";
export { ForwardRef as ReactComponent };